import { Toast } from './Toast'
import { useToast } from '../../contexts/ToastContext'
import { createPortal } from 'react-dom'

export function ToastContainer() {
  const { toasts, removeToast } = useToast()

  if (toasts.length === 0) {
    return null
  }

  const toastContent = (
    <div 
      className="fixed top-4 right-4 flex flex-col gap-4"
      style={{ zIndex: 2147483647, pointerEvents: 'auto' }}
    >
      {toasts.map(toast => (
        <div key={toast.id}>
          <Toast toast={toast} onDismiss={removeToast} />
        </div>
      ))}
    </div>
  )

  // Use portal to render outside the dialog DOM tree
  return createPortal(toastContent, document.body)
}